import React from 'react'
import './NewsLetter.css'

const NewsLetter = () => {
  return (
    <div className='newsletter'>
        <h1>Get Exclusive Offers on your Email</h1>
        <p>Subscribe to your newletter and stay updated</p>
         <div>
            <input type="email" placeholder='Your Email id' required/>
              <button>Subscribe</button>            
         </div>
    </div>
  )
}

export default NewsLetter